import { apiEmpleo } from "../../util/ApiEmpleo";

export type TUpdateContractEndNoteRequest = {
  A_ade_nota_del_candidato_a: string;
};

const apiUpdateContractEndNote = async (
  contractId: string,
  payload: TUpdateContractEndNoteRequest
) => {
  const res = await apiEmpleo.patch(
    `contracts/${contractId}/end-note`,
    payload,
    {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    }
  );

  return res;
};

export { apiUpdateContractEndNote };
